@import 'fluid-radio-group.theme.less';

@import '../../styles/mixins/fluid-form-elements.mixin.less';

// ================================================================ //
// -- Theme Definition

:host {
  display: block;

  *, ::after, ::before {
    box-sizing: border-box;
  }

  .fluid-radio-group {

    /**
     * LEGACY THEME
     */
    &.legacy {
      @import '../../styles/variables-iuw-legacy.less';
      @radio-group-tokens: @radio-group-tokens-legacy;
      @radio-group();
    }

    /**
     * LIBERTY MUTUAL THEME
     */
    &.lm {
      @import '../../styles/variables-lm.less';
      @radio-group-tokens: @radio-group-tokens-lm;
      @radio-group();
    }

    /**
     * LM CORPORATE THEME
     */
    &.corp, &.default {
      @import '../../styles/variables-lm-corp.less';
      @radio-group-tokens: @radio-group-tokens-corp;
      @radio-group();
    }

    /**
     * PORTAL THEME
     */
    &.portal {
      @import '../../styles/variables-lm-portal.less';
      @radio-group-tokens: @radio-group-tokens-portal;
      @radio-group();
    }
  }
}

// ================================================================ //
// -- Component Detached Ruleset

@radio-group: {
  @option: @radio-group-tokens[@option];

  // ==== Computed Variables

  @container-padding-y: .form-field-padding-y(
    @font-size: @font-size;
    @line-height: @line-height;
  );
  @button-container-padding-y: .form-field-padding-y(
    @font-size: @font-size;
    @line-height: @line-height;
    @offset: -4px;
  );

  // ---------------- //

  font-family: @font-family;
  font-size: @radio-group-tokens[font-size];
  line-height: @radio-group-tokens[line-height];
  color: @radio-group-tokens[color];

  // ==== Form Group

  .form-group {
    .fluid-form-group();
  }

  // ==== OUTER Container & Inline Question INNER Container

  .form-container,
  .inline-form-container {
    display: flex;
    flex-wrap: wrap;
    row-gap: 0.5em; // Sets top/bottom margin between radio buttons
    column-gap: 1.5em; // Sets left/right margin between radio buttons
  };

  // ==== OUTER Container

  .form-container {
    border-width: @border-width;
    border-style: @border-style;
    border-color: transparent;
    border-radius: @border-radius;

    @container-padding-y();

    // == Button Group Container

    &.button-group {
      @button-container-padding-y();
    }

    // == Inline Question OUTER Container

    &.inline-question {
      display: block;

      &:not(.bordered) {
        padding: 0;
      }
    }

    // == Container with Border

    &.bordered {
      padding-left: @form-field-padding-left;
      padding-right: @form-field-padding-right;
      border-color: #DDD; // TODO: Update to @color-form-field-border?
    }

    // == Validation Error Text (reduce padding when NOT bordered)

    &:not(.bordered) {
      & + .form-element-notifications {
        padding-top: 2px;
      }
    }
  }

  // ==== Inline Question Form Label (responsive)

  .inline-question-label {
    padding-bottom: 0.5em;
    max-width: 100%;

    @media @screen-md {
      display: inline-block;
      vertical-align: middle;
      padding-bottom: 0;
    }
  }

  // ==== Option Container

  .fluid-radio-option {
    flex: 0 1 auto; // Displays radio buttons side-by-side

    // == Vertical Layout

    &.vertical-layout {
      flex: 1 0 100%; // Displays radio buttons as block elements
    }

    // == Disabled State

    &.disabled {
      .radio-option-input,
      .radio-option-label,
      .info-popover {
        cursor: not-allowed;
        color: @form-field-color-disabled;
      }
    }
  }

  // ==== Input (type="radio") + Label

  .radio-option-input,
  .radio-option-label {
    display: inline;
    vertical-align: middle;
    font-size: inherit;
    cursor: pointer;
  }

  // ==== Input (type="radio")

  .radio-option-input {
    width: 1em;
    height: 1em; // Matches radio button size to label text size
    margin: -1px 0 0 0; // Necessary to vertically align radio button & label text
    outline-offset: 3px; // Increases :focus outline size
  }

  // ==== Radio Button Label

  .radio-option-label {
    line-height: @option[line-height];
    color: inherit;
    padding-left: 0.5em;

    // == "Helptext" Popover

    &:not(:empty) + .info-popover {
      margin-left: 0.375em;
    }
  }
};
